module.exports = __webpack_public_path__ + "public/1.0.1_200686/img/en-4.07906ccb.png";